import React from 'react';
import PageTemplate from '../../components/PageTemplate';

const TeamAugmentation = () => {
  return (
    <PageTemplate
      title="Team Augmentation"
      subtitle="Scale your development team with skilled professionals"
      breadcrumb="Services > Team Augmentation"
    >
      <div className="content-section">
        <div className="two-column">
          <div>
            <h3>Dedicated Development Teams</h3>
            <p>Extend your in-house team with our dedicated professionals who work exclusively on your projects. Our team augmentation services help you scale quickly without the overhead of hiring and training.</p>
            <ul className="feature-list">
              <li>Dedicated Team Members</li>
              <li>CTO as a Service</li>
              <li>Angular Development Specialists</li>
              <li>Java Development Experts</li>
              <li>.NET Development Professionals</li>
              <li>Node.js Development Team</li>
            </ul>
          </div>
          <div>
            <h4>Why Choose Our Team Augmentation?</h4>
            <div className="content-card">
              <h4>Quick Scaling</h4>
              <p>Scale your team up or down based on project requirements without long-term commitments.</p>
            </div>
            <div className="content-card">
              <h4>Cost Effective</h4>
              <p>Reduce hiring costs and overhead while accessing top-tier talent.</p>
            </div>
            <div className="content-card">
              <h4>Expert Skills</h4>
              <p>Access specialized skills and technologies that may not be available in-house.</p>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default TeamAugmentation; 